module.exports = __webpack_public_path__ + "media/images/Circle - S-a50233887e427ba5e461230b38a60983.png";